import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Button } from '../../../components/base';
import ContentTable from '../../../components/ContentTable/ContentTable.component';
import { PERSONAL_JOB_APPLICATION_TABLE_FIELDS } from '../../../constants/personnel.constant';

export default class JobApplication extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/personalia/surat/tambah-lamaran-kerja');
  }

  render() {
    const { handleGetJobApplication } = this.props;
    return (
      <div className="job-application">
        <Button
          title="Tambah Surat Lamaran Kerja"
          onClick={this.onClickAdd}
        />
        <div className="job-application__content">
          <ContentTable
            onSearchContent={handleGetJobApplication}
            tableFields={PERSONAL_JOB_APPLICATION_TABLE_FIELDS}
          />
        </div>
      </div>
    );
  }
}
JobApplication.propTypes = {
  handleGetJobApplication: PropTypes.func,
  history: PropTypes.object.isRequired,
};
JobApplication.defaultProps = {
  handleGetJobApplication: noop,
};
